export default "/images/vendor/flag-icon-css/flags/4x3/vn.svg?a3c286271bdb3ff7b16f24dec60c9555";